import { client } from "../utils/api-client";

async function fetchUserData(queryClient, token) {
  if (!token) {
    return;
  }
  let customHeaders = {
    "x-mock-response-code": "200",
  };
  try {
    const userResult = await client("profile", {
      token,
      headers: customHeaders,
    });
    queryClient.setQueryData("userData", userResult?.data, {
      staleTime: 60 * 1000, // 1 min
    });

    return userResult?.data;
  } catch (error) {
    console.error(error);
  }
}
export { fetchUserData };
